import { BranchOffices } from 'domain/branch-offices';

export interface Workplace {
  companyName: string;
  branchOfficeName: string | null;
}

const LOCALE = 'es-PE';

const normalizedName = (name: string): string => name.trim().replace(/\s+/g, ' ').toLocaleUpperCase(LOCALE);

const isSameName = (first: string, second: string): boolean => normalizedName(first) === normalizedName(second);

export const workplaceOf = ({ name, company }: BranchOffices): Workplace => {
  if (!company) return { companyName: name, branchOfficeName: null };
  return { companyName: company, branchOfficeName: isSameName(company, name) ? null : name };
};

export const workplaceDescription = ({ companyName, branchOfficeName }: Workplace): string =>
  branchOfficeName ? `${companyName} · ${branchOfficeName}` : companyName;
